<template>
    <div class="main">
        <div class="body-content">
            <h3 style="margin: 0;">Upload Party BL Excel</h3>
            <div class="form-group">
                <div class="form-item">
                    <label for="fileAdd">File:</label>
                    <input type="file" id="file" @change="handleFileUpload" class="custom-file-input">
                </div>
                <div class="form-item">
                    <button type="button" class="excel-button" @click="uploadFiles" :disabled="isSubmitting">Upload</button>
                    <button type="button" class="excel-button" @click="savequery" :disabled="isSubmitting">Save</button>
                </div>
                <div>{{ message }}</div>
            </div>
            <div v-if="transactions.length === 0" class="no-data">
                <p>No data available</p>
            </div>
            <div v-else>
                <div class="table-container">
                    <table class="transaction-table table-design">
                        <thead>
                            <tr>
                                <th><span>Sl No</span></th>
                                <th><span>Booking No</span></th>
                                <th><span>Bl No</span></th>
                                <th style="width:20px"><span>Container No</span></th>
                                <th><span>Package</span></th>
                                <th><span>Cargo Wt</span></th>
                                <th><span>Tare Wt</span></th>
                                <th><span>Status</span></th>

                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(transaction, index) in transactions" :key="index">
                                <td>{{ index + 1 }}</td>
                                <td>{{ transaction.booking }}</td>
                                <td>{{ transaction.blno }}</td>
                                <td>{{ transaction.contno }}</td>
                                <td>{{ transaction.noofpackages }}</td>
                                <td>{{ transaction.cargo_wt }}</td>
                                <td>{{ transaction.tare_wt }}</td>
                                <td>{{ transaction.status || '' }}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import axios from 'axios';
import { useToast } from 'vue-toastification';



export default {
    data() {
        return {
            newContainer: {
                file: null
            },
            message: '',
            transactions: [],
            isSubmitting: false,
        };
    },
    methods: {
        handleFileUpload(event) {
            this.newContainer.file = event.target.files[0];
        },
        async uploadFiles() {
            if (this.isSubmitting) return;
            
            if (this.newContainer.file == null) {
                useToast().error("Select file");
                return;
            }
            
            this.isSubmitting = true;
            
            try {
                const token = localStorage.getItem('access_token');
                const config = {
                    headers: {
                        //'accept': 'application/json',
                        'Authorization': `Bearer ${token}`, // Include the token in the headers
                        //'Content-Type': 'multipart/form-data'
                    },
                    maxContentLength: Infinity,
                    maxBodyLength: Infinity,
                    timeout: 15 * 60 * 1000, // 15 minutes timeout
                    //onUploadProgress: progressEvent => {
                    //    const percent = Math.round((progressEvent.loaded * 100) / progressEvent.total);
                    //    //console.log(`Upload progress: ${percent}%`);
                    //}
                };
                this.message = "Wait, uploading file...";
                const data = new FormData();
                data.append('file', this.newContainer.file);

                const response = await axios.post('/upload_party_bl', data, config);
                //console.log(response)
                if (response.data[0] === 0) {
                    this.message = response.data[1];
                    useToast().error(response.data[1]);
                } else {
                    this.message = "File uploaded successfully";
                    useToast().success("File uploaded successfully");
                    this.transactions = response.data[2];
                    //this.newContainer.file = null; // Reset the file input after successful upload
                }
            } catch (error) {
                this.message = "An error occurred during upload.";
                useToast().error(error.response?.data?.message || "An error occurred during upload.");
                console.error(error);
            } finally {
                this.isSubmitting = false;
            }
        },
        async savequery() {
            if (this.isSubmitting) return;
            
            if (this.transactions === null) {
                useToast().error('Please select a file to upload');
                return;
            }
            
            this.isSubmitting = true;
            
            try {
                this.message = "Saving data...";
                const token = localStorage.getItem('access_token');
                const config = {
                    headers: {
                        'accept': 'application/json',
                        'Authorization': `Bearer ${token}`,
                    },
                    'maxContentLength': Infinity,
                    'maxBodyLength': Infinity
                };
                const qrydata = { data: this.transactions }
                const data = new FormData();
                const transdt = JSON.stringify(qrydata)
                //data.append('transaction', transdt)
                data.append(
                    'transaction',
                    new Blob([transdt], { type: 'application/json' }),
                    'transactions.json'
                );
                
                const response = await axios.post('/save_party_bl', data, config);
                //console.log(response.data)
                this.message = response.data[1];
                if (response.data[0] === 0) {
                    useToast().error(response.data[1]);
                } else {
                    useToast().success(response.data[1]);
                    this.transactions = response.data[2]
                }
            } catch (error) {
                useToast().error(error.response?.data?.message || "An error occurred during save.");
                console.error(error);
            } finally {
                this.isSubmitting = false;
            }
        },
    }
}
</script>
<style scoped>
.form-item {
    width: 30%;
}

.excel-button {
    background-color: #17a2b8;
    color: white;
    border: none;
    padding: 10px 15px;
    border-radius: 5px;
    cursor: pointer;
    margin-right: 10px;
}

.excel-button:disabled {
    background-color: #6c757d;
    cursor: not-allowed;
    opacity: 0.6;
}
</style>